import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext.jsx';
import { ToastProvider } from './components/ui.jsx';
import AppLayout from './components/AppLayout.jsx';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import UploadPage from './pages/UploadPage.jsx';
import MappingsPage from './pages/MappingsPage.jsx';
import RegistryPage from './pages/RegistryPage.jsx';
import VehiclesPage from './pages/VehiclesPage.jsx';
import InsurersPage from './pages/InsurersPage.jsx';
import AnalyticsPage from './pages/AnalyticsPage.jsx';
import ImportsPage from './pages/ImportsPage.jsx';
import AdminPage from './pages/AdminPage.jsx';

/** Theme preference is remembered locally; it has no server-side effect. */
function useTheme() {
  const [theme, setTheme] = useState(() => window.localStorage.getItem('mmv.theme') || 'light');
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem('mmv.theme', theme);
  }, [theme]);
  return [theme, setTheme];
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="login-page"><div className="spinner" /></div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export default function App() {
  const [theme, setTheme] = useTheme();

  return (
    <ToastProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={(
            <RequireAuth>
              <AppLayout theme={theme} onToggleTheme={() => setTheme(theme === 'dark' ? 'light' : 'dark')} />
            </RequireAuth>
          )}
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/imports" element={<ImportsPage />} />
          <Route path="/mappings" element={<MappingsPage />} />
          <Route path="/registry" element={<RegistryPage />} />
          <Route path="/registry/:universalKey" element={<RegistryPage />} />
          <Route path="/vehicles" element={<VehiclesPage />} />
          <Route path="/insurers" element={<InsurersPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ToastProvider>
  );
}
